import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function FateOption(props) {
  const {
    onSelect,
    id,
    isBreakdownVisible,
    isSelected,
    data,
  } = props;

  return (
    <li
      className={classnames(
        'fate-option',
        isBreakdownVisible && 'fate-option--breakdown-visible',
        isSelected && 'fate-option--selected',
      )}
    >
      <input
        className="fate-option__radio"
        type="radio"
        name="nexAmount"
        onChange={() => onSelect(data)}
        value={id}
        id={id}
        checked={isSelected}
      />
      <label className="fate-option__label" htmlFor={id}>
        {data.quantity}
        {' '}
        FATE
        {' '}
        {data.currency.sign}
        <span className="my-price">{data.currencyAmount.toFixed(2)}</span>
      </label>
    </li>
  );
}

FateOption.displayName = 'FateOption';

FateOption.propTypes = {
  data: PropTypes.shape({}).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isBreakdownVisible: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};